// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$FileList = require("../common/Components/FileList.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyPageFiles_property_graphql = require("../../__generated__/PropertyPageFiles_property_graphql.bs.js");

var convertFragment = PropertyPageFiles_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageFiles_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageFiles_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageFiles_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageFiles_property_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__Files$WithoutErrorBoundary(props) {
  var property = use(props.property);
  var files = Core__Array.filterMap(property.files.edges, (function (x) {
            return x;
          })).map(function (param) {
        return param.node;
      });
  return JsxRuntime.jsx($$FileList.make, {
              files: files.map(function (x) {
                    return x.fragmentRefs;
                  }),
              showTitle: props.showTitle
            });
}

var WithoutErrorBoundary = {
  make: PropertyPage__Files$WithoutErrorBoundary
};

function PropertyPage__Files(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "Property files",
              children: JsxRuntime.jsx(PropertyPage__Files$WithoutErrorBoundary, {
                    property: props.property,
                    showTitle: props.showTitle
                  })
            });
}

var make = PropertyPage__Files;

exports.Fragment = Fragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* FileList Not a pure module */
